import { API_BASE, NEXT_API_BASE } from '@/Module/Core/Constant';

export const SUBSCRIPTION_API = {
  GET_TYPE: `${API_BASE}/Common/GetSubscriptionType`,
  GET_PANEL: `${API_BASE}/SubscriptionPlan`,
  GET_SUBSCRIPTIONS_V2_USER: `${API_BASE}/v2/Subscriptions/plans`,
  BUY_SUBSCRIPTION: `${API_BASE}/SubscriptionCart/SubscriptionRequest`,
  VERIFY_PAYMENT: `${API_BASE}/SubscriptionCart/api/subscription-carts/orders/{order_id}`,
  CALC_PRICE_SUBSCRIPTION: `${API_BASE}/SubscriptionCart/CalcPrice`,
  COURSE_HAS_SUBSCRIPTION: `${API_BASE}/SubscriptionPlan/checkCourse/{courseId}`,
  COURSE_HAS_SUBSCRIPTION_V2: `${API_BASE}/v2/subscription-plans/courses/{course_id}/validate-access`,
  GET_TRANSACTION_LIST: `${API_BASE}/v2/payment-transactions`,
  RUBIKA_PAYMENT: `${API_BASE}/rubika/payments/request`,
  RUBIKA_PAYMENT_VERIFY: `${API_BASE}/rubika/payments/verify`,
  REVERSE_COUPON: `${API_BASE}/coupon/reverse`,
  SHAD: `${NEXT_API_BASE}/shad/payment`,
  SHAD_PAYMENT_REQUEST: `${API_BASE}/shad/payments/request`,
  SHAD_PAYMENT_VERIFY: `${API_BASE}/shad/payments/verify`,
};
